/*
 * @LastEditors: Yx
 * @LastEditTime: 2022-08-04 14:13:01
 * @Description:
 * @Author: Yx
 * @Date: 2022-07-15 17:04:50
 * @FilePath: \szjzsoft-framework\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/css/index.scss";
import "./plugins/element.js";

Vue.config.productionTip = false;
Vue.prototype.$isMobile = document.documentElement.clientWidth < 768;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
